<footer class="app-footer">
  <nav class="app-footer__links" aria-label="Legal and support links">
    <a [href]="supportUrl" target="_blank" rel="noopener noreferrer">Contact Support</a>
    <span class="app-footer__separator" aria-hidden="true"></span>
    <a [href]="termsOfUseUrl" target="_blank" rel="noopener noreferrer">Terms of Use</a>
  </nav>
</footer>
